<template>
      <div class="switch-box">
        <el-row>
          <p style="">
            {{ data.label }}
          </p>
        </el-row>
        <el-form-item>
          <el-switch
            :disabled="disabled"
            size=""
            style="
              --el-switch-on-color: #13ce66;
              --el-switch-off-color: #ff4949;
            "
            active-text="Si"
            inactive-text="No"
            v-model="data.model"
            @change="saveDataToLocalStorage(data.model, data.name)"
          />
        </el-form-item>
          <el-form-item v-if="data.model" :label="data.companyDataPerception.label" style="width:40%">
            <el-col :span="23">
              <el-input :disabled="disabled" @input="saveDataToLocalStorage(data.companyDataPerception.model, data.companyDataPerception.name)" :class="verifyFields (data.companyDataPerception, validation) ? 'input-warning':''" :type="'number'" v-model="data.companyDataPerception.model" style="margin-left:4%"/>
              <el-alert v-if="verifyFields (data.companyDataPerception, validation)" :title="`Falta completar: ${data.companyDataPerception.label}`" type="error" class="message-warning" :closable="false" style="margin-left:4%"/>
            </el-col>
          </el-form-item>
      </div>
</template>

<script>
import { verifyFields, persistToNewProviderStorage, saveDataToLocalStorage } from '../helpers/utils.js'
export default {
  data () {
    return {
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {},
  methods: {
    verifyFields,
    persistToNewProviderStorage,
    saveDataToLocalStorage
  }
}
</script>



// WEBPACK FOOTER //
// SwitchPerception.vue?64a212a0